import { Utils } from '../../../utils';

import type { GetSearchLocation } from '../../../types';

const getLocationType = (item: GetSearchLocation) => {
  switch (item.regionType) {
    case 'airport':
      return 'flight';
    case 'neighborhood':
      return 'apartment';
    default:
      return 'place';
  }
};

const getLocationAmountOfStores = (item: GetSearchLocation) => {
  const isAirport = item.regionType === 'airport';
  const amountOfStores = item.stores;

  if (item.stores <= 0) {
    return null;
  } else if (isAirport) {
    return `${Utils.format.formatStringsToPlural('loja', amountOfStores)} neste aeroporto`;
  }

  return `${Utils.format.formatStringsToPlural('loja', amountOfStores)} nesta localidade`;
};

export const ListItemUtils = {
  getLocationType,
  getLocationAmountOfStores,
};
